import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// vuescreen
import VueScreen from 'vue-screen'

// Tailwind css
import '@/styles.css'
import './assets/tailwind.css'

createApp(App).use(VueScreen, 'tailwind').use(store).use(router).mount('#app')
